import { useState, useEffect } from 'react';

export const useDataTableData = (dth, refreshData, fetchFunction, paginationLoaded) => {
  const [data, setData] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    if (paginationLoaded && dth?.current?.pagination) {
      async function fetchData() {
        try {
          const objectToSend = {
            skip: dth.current.pagination.pageNo * dth.current.pagination.itemsPerPage,
            amount: dth.current.pagination.itemsPerPage,
            sort_by: dth.current.sortStatus.currentKey,
            sort_order: dth.current.sortStatus.direction,
          };
          const data = await fetchFunction(objectToSend);
          setData(data.data);
          setLastUpdated(data?.lastUpdated);
          dth.current.setServerDataLength(data.totalItems);
        } catch (err) {
          console.log('Error retrieving data');
          console.log('err', err);
        }
      }

      fetchData();
    }
  }, [dth, paginationLoaded]);

  useEffect(() => {
    if (Object.keys(refreshData).length) {
      async function fetchData() {
        try {
          const objectToSend = {
            skip: refreshData?.pagination?.pageNo * refreshData?.pagination?.itemsPerPage,
            amount: refreshData?.pagination?.itemsPerPage,
            sort_by: refreshData?.sortStatus?.currentKey,
            sort_order: refreshData?.sortStatus?.direction,
            search: refreshData?.search,
            filter: refreshData?.filter,
          };
          const data = await fetchFunction(objectToSend);
          setData(data.data);
          setLastUpdated(data?.lastUpdated);
          if (typeof refreshData?.setPaginationLength === 'function') {
            refreshData?.setPaginationLength?.(data.totalItems);
          } else {
            dth.current.setServerDataLength(data.totalItems);
          }
        } catch (err) {
          console.log('Error retrieving data');
          console.log('err', err);
        }
      }

      fetchData();
    }
  }, [refreshData]);

  return { data, lastUpdated };
};
